import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AppShell from './AppShell';

/**
 * Estrutura padrão das páginas internas.
 * breadcrumbs: [{ label, to? }] — o último item é a página atual.
 */
export default function PageLayout({ title, subtitle, breadcrumbs = [], actions, maxWidth = 1440, children }) {
    const navigate = useNavigate();

    return (
        <AppShell>
            <Box sx={{ px: { xs: 2, sm: 3, lg: 4 }, py: { xs: 2.5, sm: 3 }, maxWidth, mx: 'auto', width: '100%' }}>
                {breadcrumbs.length > 0 && (
                    <Breadcrumbs
                        aria-label="breadcrumb"
                        separator={<NavigateNextIcon sx={{ fontSize: 16 }} />}
                        sx={{ mb: 1.5, color: 'text.secondary' }}
                    >
                        {breadcrumbs.map((crumb, index) => {
                            const isLast = index === breadcrumbs.length - 1;
                            if (isLast || !crumb.to) {
                                return (
                                    <Typography key={crumb.label} sx={{ fontSize: 'inherit', color: isLast ? 'text.primary' : 'inherit', fontWeight: isLast ? 500 : 400 }}>
                                        {crumb.label}
                                    </Typography>
                                );
                            }
                            return (
                                <Link
                                    key={crumb.label}
                                    underline="hover"
                                    color="inherit"
                                    component="button"
                                    type="button"
                                    onClick={() => navigate(crumb.to)}
                                    sx={{ fontSize: 'inherit', verticalAlign: 'baseline' }}
                                >
                                    {crumb.label}
                                </Link>
                            );
                        })}
                    </Breadcrumbs>
                )}

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: { xs: 'flex-start', md: 'flex-end' },
                        justifyContent: 'space-between',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: 2,
                        mb: 3,
                    }}
                >
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="h2" component="h1">
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                    {actions && (
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', flexShrink: 0 }}>
                            {actions}
                        </Box>
                    )}
                </Box>

                {children}
            </Box>
        </AppShell>
    );
}
